export default "دی\nیا\nچیرته\nڅه\nهغه څنګه\nڅومره\nباید\nکولی شي"